import { render, staticRenderFns } from "./characters.vue?vue&type=template&id=ef9af746&"
import script from "./characters.vue?vue&type=script&lang=js&"
export * from "./characters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports